import React from 'react';
import { Navigate } from 'react-router-dom';
import { urls } from '../utils';

export const NotFound: React.FC = () => <Navigate to={urls.login} replace />;
